export enum ReturnNoteType {
  'GasAnalyser' = 2,
  'GasMixer' = 1,
  'LeakDetection' = 3
}

export interface IMasterData {
  id: string,
  name: string
}

export interface IReturnNoteMasterData {
  listOfModels: IMasterData[],
  listOfReasons: IMasterData[],
  listOfActions: IMasterData[],
  listOfGases: IMasterData[],
  listOfEquipments: IMasterData[]
}

export interface IReturnNote {
  masterData: IReturnNoteMasterData
  id: number,
  productTypeID: number,
  customerId: string,
  currentColPosition: number,
  serialNo: number,
  raisedByUserId: string,
  raisedBy: string,
  raisedByDate: string,
  year: number,
  voltage: number | string,
  model: string[],
  reason: string[],
  warranty: number,
  hireUnit: boolean,
  urgent: boolean,
  notes: string,
  faultDescription: string,
  reasonForReturn: string,
  action: string[],
  gases: string[],
  selectedEquipments: any,
  returnNo: string,
  comments: string,
  commentsHistories: any[],
  isLocked: boolean;
  message: string;
  modelOtherValue: string;
  equipmentOther1Value: string
  equipmentOther2Value: string
}

export enum MasterDataFields {
  model = 'model',
  gases = 'gases',
  reason = 'reason',
  action = 'action'
}